import HamburgerMenu from './HamburgerMenu';
import './Header.css';
import ItemsAndPostsIcon from './ItemsAndPostsIcon';
import MyInfoIcon from './MyInfoIcon';
import SettingsIcon from './SettingsIcon';
import Logo from './logo';
import ProfileMenu from './ProfileMenu';
import MobileLogo from './MobileLogo';
import { NavLink } from 'react-router-dom';
import { useRole } from '../../hooks/useRole';
import NotificationsIcon from './NotificationsIcon';
import AdminDashboardIcon from './AdminDashboardIcon';

export default function Header({ className }) {
  const { role } = useRole();
  const isNotRegularUser = role !== 'user';

  return (
    <>
      <div className={`header ${className || ''}`}>
        <div className='header-content'>
          <div className='logo-wrap'>
            <MobileLogo />
            <Logo />
          </div>
          <div className='icons-wrap'>
            <NavLink to='/swapandtop/postnewitem'>
              <button className='new-post-btn'>Post New Item</button>
            </NavLink>
            <NavLink
              to='/swapandtop/myitemsandposts'
              className={'navLink-header-icon'}>
              <ItemsAndPostsIcon
                svgClass={'header-icon'}
                wrapperClass={'header-icon-wrap'}
              />
            </NavLink>
            <NavLink
              to='/swapandtop/settings'
              className={'navLink-header-icon'}>
              <SettingsIcon
                svgClass='header-icon'
                wrapperClass={'header-icon-wrap'}
              />
            </NavLink>
            <NotificationsIcon
              svgClass='header-icon'
              wrapperClass={'header-icon-wrap'}
            />
            {isNotRegularUser && (
              <NavLink to='/swapandtop/admin' className={'navLink-header-icon'}>
                {/* <div
                  className='header-icon-wrap'
                  style={{
                    width: '24px',
                    height: '24px',
                    borderRadius: '50%',
                    backgroundColor: 'white',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                /> */}
                <AdminDashboardIcon
                  svgClass='header-icon'
                  wrapperClass={'header-icon-wrap'}
                />
              </NavLink>
            )}
            <ProfileMenu />
            <HamburgerMenu />
          </div>
        </div>
      </div>
    </>
  );
}
